import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import { makeStyles, useTheme } from "@mui/styles";

import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "60vh",
    width: "100%",
    // background: "#f98f19",
  },
  wrapper: {
    width: "90%",
    padding: theme.spacing(4),
    borderRadius: theme.spacing(2),
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
  },
  card: {
    height: "30vh",
    backgroundColor: "#fff",
    transition: "transform 0.2s",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
    border: "2px solid #f98f19",
    borderRadius: theme.spacing(2),
    overflow: "hidden",
    "&:hover": {
      transform: "scale(1.05)",
      boxShadow: "0 0 10px rgba(0, 0, 0, 0.3)",
    },
  },
  cardContent: {
    padding: theme.spacing(2),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    flexDirection: "column",
    textAlign: "center",
  },
  title: {
    // fontWeight: "bold",
    marginBottom: theme.spacing(1),
    color: "#f98f19",
    fontSize: "2rem" /* Increase font size */,
    fontWeight: 600,
  },
  subtitle: {
    fontSize: "1.2rem",
    color: "#777",
    marginTop: theme.spacing(1),
  },
}));

function SurveyCards() {
  const classes = useStyles();
  return (
    <Box className={classes.container}>
      <Box className={classes.wrapper}>
        <Grid container spacing={4} justifyContent="center" height="100%">
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Link to="/abinbev-survey" style={{ textDecoration: "none" }}>
              <Card className={classes.card}>
                <CardContent className={classes.cardContent}>
                  <Typography variant="" className={classes.title}>
                    AbInBev Survey
                  </Typography>
                  <Typography variant="body1" className={classes.subtitle}>
                    Take our survey and get a chance to win a free ..
                  </Typography>
                </CardContent>
              </Card>
            </Link>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Link to="/nbev-survey" style={{ textDecoration: "none" }}>
              <Card className={classes.card}>
                <CardContent className={classes.cardContent}>
                  <Typography variant="" className={classes.title}>
                  Nbev Consumer
                  </Typography>
                  <Typography variant="body1" className={classes.subtitle}>
                    Share your thoughts with us and get a chance to win ..
                  </Typography>
                </CardContent>
              </Card>
            </Link>
          </Grid>
          <Grid item xs={12} sm={10} md={4} lg={3}>
            <Link to="/sab-survey" style={{ textDecoration: "none" }}>
              <Card className={classes.card}>
                <CardContent className={classes.cardContent}>
                  <Typography variant="" className={classes.title}>
                    SAB
                  </Typography>
                  <Typography variant="body1" className={classes.subtitle}>
                    Help us improve our products and services and get a chance
                    to ..
                  </Typography>
                </CardContent>
              </Card>
            </Link>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default SurveyCards;
